import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/verktoy/vo2-max-kalkulator/VO2MaxCalculator.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ShareBar"] */ "/vercel/path0/components/shared/ShareBar.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/link.js");
